/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Console_Copy_PromptInputs */

const en_console_copy_prompt = /** @type {(inputs: Console_Copy_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy prompt`)
};

const zh_hans1_console_copy_prompt = /** @type {(inputs: Console_Copy_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制提示词`)
};

const pt_br2_console_copy_prompt = /** @type {(inputs: Console_Copy_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar prompt`)
};

const es_console_copy_prompt = /** @type {(inputs: Console_Copy_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar prompt`)
};

const fr_console_copy_prompt = /** @type {(inputs: Console_Copy_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier le prompt`)
};

const de_console_copy_prompt = /** @type {(inputs: Console_Copy_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt kopieren`)
};

const ru_console_copy_prompt = /** @type {(inputs: Console_Copy_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать промпт`)
};

const it_console_copy_prompt = /** @type {(inputs: Console_Copy_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia prompt`)
};

/**
* | output |
* | --- |
* | "Copy prompt" |
*
* @param {Console_Copy_PromptInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const console_copy_prompt = /** @type {((inputs?: Console_Copy_PromptInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Copy_PromptInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_console_copy_prompt(inputs)
	if (locale === "pt-BR") return pt_br2_console_copy_prompt(inputs)
	if (locale === "es") return es_console_copy_prompt(inputs)
	if (locale === "fr") return fr_console_copy_prompt(inputs)
	if (locale === "de") return de_console_copy_prompt(inputs)
	if (locale === "ru") return ru_console_copy_prompt(inputs)
	if (locale === "it") return it_console_copy_prompt(inputs)
	return en_console_copy_prompt(inputs)
});